import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useCookie } from '@trinity/chat-components/hooks/useCookie';
import { useGroupFeatures } from '../Chat';
import { ChatWelcomeScreenContext } from './Context';

const cookie = {
  name: 'msl-copilot:chat-welcome-screen-visibility',
  hidden: 'hidden',
};

type Props = {
  children: React.ReactNode;
};

export const ChatWelcomeScreenContainer = (props: Props) => {
  const features = useGroupFeatures();
  const enabled = features.chatWelcomeScreen;
  const content = features.chatWelcomeScreenContent || null;

  const [value, setCookie] = useCookie(cookie.name);

  const prevEnabledRef = useRef<boolean | null>(null);
  useEffect(() => {
    if (prevEnabledRef.current === null) {
      prevEnabledRef.current = enabled;
      if (!enabled && value === cookie.hidden) {
        setCookie({ expires: new Date('2100-01-01'), value: '' });
      }
      return;
    }
    if (prevEnabledRef.current === true && !enabled) {
      setCookie({ expires: new Date('2100-01-01'), value: '' });
    }
    prevEnabledRef.current = enabled;
  }, [enabled, setCookie, value]);

  const visible = useMemo(() => {
    return value !== cookie.hidden && enabled;
  }, [enabled, value]);

  const dismiss = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: cookie.hidden,
    });
  }, [setCookie]);

  const reset = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: '',
    });
  }, [setCookie]);

  const ctx = {
    dismiss,
    enabled,
    content,
    reset,
    visible,
  };

  return <ChatWelcomeScreenContext.Provider value={ctx}>{props.children}</ChatWelcomeScreenContext.Provider>;
};

ChatWelcomeScreenContainer.displayName = 'ChatWelcomeScreen.Container';
